// extracted by mini-css-extract-plugin
export default {"carousel":"carousel_carousel__sM9VD","card-container":"carousel_card-container__E521m","nav":"carousel_nav__leqhR","left":"carousel_left__+4kTC","right":"carousel_right__CBAOP"};